
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  UncontrolledTooltip,
} from "reactstrap";
// Formik validation

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getSettings, updateSetting } from "../../store/settings/actions";
import FormEditors from "../Forms/FormEditors";


const AboutUs = (props) => {
  const dispatch = useDispatch()
  const settings = useSelector(state=>state.settings.settings)
  const [about_us_ar, setAboutUsAr] = useState("")
  const [about_us_en, setAboutUsEn] = useState("")
  const [about_us_fr, setAboutUsFr] = useState("")
  useEffect(() => {
  dispatch(getSettings())
  }, [dispatch])
  useEffect(() => {
    setAboutUsAr(settings.about_us_ar)
    setAboutUsEn(settings.about_us_en)
    setAboutUsFr(settings.about_us_fr)
  },[settings])
    const handleSubmit = () => {
      dispatch(
        updateSetting({
          id:settings.id ?? 1,
          about_us_ar,
          about_us_en,
          about_us_fr,
        })
      )
    }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="About us" breadcrumbItem="" />
          <Row>
            <Col xl="6"></Col>

            <Col xl="6"></Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4>About us</h4>
                  <p className="card-title-desc">
                    {/* Parsley is a availity reactstrap validation. It helps you
                    provide your users with feedback on their form submission
                    before sending it to your server. */}
                  </p>
                  <Label>
                    <h4 className="card-title">English</h4>
                  </Label>

                  <FormEditors value={about_us_en} onChange={setAboutUsEn} />
                  <Label>
                    <h4 className="card-title">French</h4>
                  </Label>
                  <FormEditors value={about_us_fr} onChange={setAboutUsFr} />
                  <Label>
                    <h4 className="card-title">Arabic</h4>
                  </Label>
                  <FormEditors value={about_us_ar} onChange={setAboutUsAr} />
                  <div className="d-flex flex-wrap gap-2">
                    <Button type="button" color="primary" className="" onClick={handleSubmit}>
                      Submit
                    </Button>{" "}
                    <Button type="reset" color="secondary" className="">
                      Cancel
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
};

export default AboutUs
